import {Constants} from '@/utils/constants/commonConstants'

export const uploadFileDescriptionForCSV = () => {
  return (
    <div>
      <span>{Constants.DragAndDrop}</span>
      <br />
      <span>{Constants.OnlyCsv}</span>
    </div>
  )
}
